export default __webpack_public_path__ + "static/media/working_conditions.9a946e0b.svg";